import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ZefFormsModule } from '@zerops/zef/forms';
import { MaterialFormStackModule } from '@zerops/zerops/core/material-form-stack';
import { TopUpAmountFormComponent } from './top-up-amount-form.component';

@NgModule({
  declarations: [ TopUpAmountFormComponent ],
  imports: [
    CommonModule,
    ZefFormsModule,
    MaterialFormStackModule,
    MatIconModule
  ],
  exports: [ TopUpAmountFormComponent ]
})
export class TopUpAmountFormModule {

}
